import moment from 'moment';
import { keyBy, range } from 'lodash-es';
import { TMetricValueList } from '@intelligence/pages/Compare/PcConsoleGamesBeta/components/VisualList';

type TDateType = 'daily' | 'weekly' | 'monthly';

export const DateTypePrefixMap: { [key: string]: string } = {
  daily: 'D',
  weekly: 'W',
  monthly: 'M',
};

interface IFillInEmptyDataProps {
  dateType: TDateType;
  currentMetricData: TMetricValueList;
  responseQueryDate?: { startDate: string | number; endDate: string | number };
  isAlignToRelease?: boolean;
}

/**
 * 空数据补齐
 *
 * @param {IFillInEmptyDataProps} param0
 * @param {TMetricValueList} param0.currentMetricData
 * @param {TDateType} param0.dateType
 * @param {{ startDate: string; endDate: string; }} param0.responseQueryDate
 * @param {boolean} param0.isAlignToRelease
 * @returns {*}
 */
export const fillInEmptyData = ({
  currentMetricData,
  responseQueryDate,
  dateType,
  isAlignToRelease,
}: IFillInEmptyDataProps) => {
  const { startDate, endDate } = responseQueryDate || {};

  if (!startDate || !endDate) return currentMetricData;

  // 当前指标无可用数据，不处理补空
  const hasValue = currentMetricData?.find(
    (item: any) => item?.value !== null || item?.value !== undefined,
  );
  if (!hasValue) {
    return currentMetricData;
  }

  const dateDataMap = keyBy(currentMetricData, 'date');
  const range = isAlignToRelease
    ? generateRelativeDateRange(startDate as number, endDate as number, dateType)
    : generateDateRange(startDate as string, endDate as string, dateType);

  const data = range.map((date) => {
    if (dateDataMap?.[date]) {
      return dateDataMap?.[date];
    }
    return {
      date,
    };
  });

  return data;
};

/**
 * 生成当前请求日期区间数组
 *
 * @param {string} startDate
 * @param {string} endDate
 * @param {TDateType} dateType
 * @returns {{}}
 */
function generateDateRange(startDate: string, endDate: string, dateType: TDateType) {
  const dates = [];

  // 使用 moment 解析日期
  const currentDate = moment(startDate);
  const end = moment(endDate);

  // 如果是周，调整 startDate 和 endDate
  if (dateType === 'weekly') {
    // 获取本周的第一天（周一）
    currentDate.startOf('week');
    // 获取结束周的最后一天（周日）
    end.endOf('week');
  }

  // 生成日期范围
  while (currentDate.isSameOrBefore(end, 'day')) {
    dates.push(currentDate.format('YYYY-MM-DD'));

    // 根据步长更新当前日期
    if (dateType === 'daily') {
      currentDate.add(1, 'day'); // 增加1天
    } else if (dateType === 'weekly') {
      currentDate.add(1, 'week'); // 增加1周
    } else if (dateType === 'monthly') {
      currentDate.add(1, 'month'); // 增加1月
    }
  }

  return dates;
}

function generateRelativeDateRange(start: number, end: number, dateType: TDateType) {
  let relativeDateRange: (string | number)[] = range(start, end + 1);
  const dateTypePrefix = DateTypePrefixMap[dateType];
  relativeDateRange = relativeDateRange.map((item) => dateTypePrefix + item);
  return relativeDateRange;
}
